export type Language = 'en' | 'da' | 'sv' | 'de' | 'nb'

const LOCALES: Record<Language, string> = {
  en: 'en-US',
  da: 'da-DK',
  sv: 'sv-SE',
  de: 'de-DE',
  nb: 'nb-NO',
}

export function localeFor(lang: Language): string {
  return LOCALES[lang]
}

const formatters = new Map<string, Intl.NumberFormat>()

/** `currency` may be whatever a misconfigured place/cart/change payload
 *  contains (a non-ISO code such as `"kr"`, or `""`) — `Intl.NumberFormat`
 *  throws `RangeError` for those. Fall back to plain number formatting
 *  rather than let one bad currency code take down every render on this
 *  till, and cache the fallback decision so it isn't re-thrown every time. */
function buildFormatter(locale: string, currency: string): Intl.NumberFormat {
  try {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  } catch {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
  }
}

export function amountCurrency(amount: number, currency: string, locale: string): string {
  const key = `${locale}:${currency}`
  let formatter = formatters.get(key)
  if (!formatter) {
    formatter = buildFormatter(locale, currency)
    formatters.set(key, formatter)
  }
  return formatter.format(amount).replace(/\u00A0/g, ' ')
}
